import React, { useEffect, useState } from "react";
import { useUI } from "../../context/UIContext";
import { ReportAPI } from "../../api/apiClient";

interface DisposedSummaryItem {
  materialName: string;
  unit: string;
  totalDisposed: number;
}

export default function MaterialDisposedSummary() {
  const { selectedProjectId } = useUI();
  const [data, setData] = useState<DisposedSummaryItem[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchSummary = async () => {
    try {
      setLoading(true);

      const result = await ReportAPI.getMaterialDisposedSummary({
        project: selectedProjectId!,
        vendor: -1,   // ✅ Important: allow all vendors
        cmp: 0
      });

      setData(result);
    } catch (error) {
      console.error("Error loading disposed summary:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedProjectId) {
      fetchSummary();
    }
  }, [selectedProjectId]);

  return (
    <div className="max-w-md bg-white rounded-lg shadow-md overflow-hidden">

      {/* Header */}
     {/* <div className="bg-blue-800 text-white font-semibold px-4 py-3 uppercase text-sm tracking-wide"> */}
         <div className="bg-[#1788ac] text-white font-semibold px-4 py-3 uppercase text-sm tracking-wide"> 
        Disposed Materials
      </div>

      {/* Loading State */}
      {loading && (
        <div className="p-6 bg-gray-100 text-gray-600">
          Loading...
        </div>
      )}

      {/* Data Cards */}
      {!loading && data.length > 0 && (
        <>
          {data.map((item, index) => (
            <div
              key={index}
              className="relative bg-gray-100 px-5 py-6"
            >
              {/* Material Name */}
              <div className="text-gray-700 text-sm mb-3">
                {item.materialName}
              </div>

              {/* Quantity */}
              <div className="text-2xl font-bold text-red-600">
                {item.totalDisposed.toFixed(2)}
                <span className="text-base font-medium ml-2 text-gray-700">
                  {item.unit}
                </span>
              </div>

              {/* Bottom Accent Line */}
             {/* <div className="absolute bottom-0 left-0 w-full h-1 bg-green-700"></div>*/}
            </div>
          ))}
        </>
      )}

      {/* No Data State */}
      {!loading && data.length === 0 && (
        <div className="p-6 bg-gray-100 text-gray-500 text-sm">
          No Data Available
        </div>
      )}
    </div>
  );
}